import Joi from 'joi';

const date = (props, propName) => {
  const { error } = Joi.validate(props[propName], Joi.date());
  return error;
};

export default date;
